import React from 'react';
import styled from 'styled-components';
import Particle from '../Components/Particle';
import Skills from '../Components/Skills';
import Resume from '../Components/Resume';
import { MainLayout } from '../styles/Layouts';

function ResumePage() {
  return (
    <MainLayout>
      <Particle />
      <ResumeStyled>
        <Skills />
        <Resume />
      </ResumeStyled>
    </MainLayout>
  );
}

const ResumeStyled = styled.section``;

export default ResumePage;
